import BaseState from "Engine/base/states/BaseState";
import EntryPoint from "Engine/EntryPoint";

export default class JackpotGameOutState extends BaseState {

    constructor(stateData) {
        super(stateData);

    }

    start() {
        super.start();
        if (this.active)
            this.complete();
    }

    onEnd() {
        super.onEnd();
        const state =  EntryPoint.GameModel.bonusGameEnabled ? OPUtility.ControllerStatistic.gameStateTypes.EGST_BONUS_GAME : OPUtility.ControllerStatistic.gameStateTypes.EGST_REGULAR;
        OPWrapperService.infoPanel.setGameState(state);
    }
}
